import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { getServiceBySlug, getServices } from '../services/api';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppFloat from '../components/WhatsAppFloat';

const ServiceDetailPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [otherServices, setOtherServices] = useState([]);

  useEffect(() => {
    setLoading(true);
    getServiceBySlug(slug).then(data => {
      if (data && data.data) {
        setService(data.data);
      } else if (data && data.id) {
        setService(data);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [slug]);

  useEffect(() => {
    getServices().then(data => {
      if (data && data.length > 0) {
        const filtered = data.filter(s => (s.slug || s.id) !== slug).slice(0, 4);
        setOtherServices(filtered.map(s => ({
          id: s.id,
          name: s.title || s.name,
          slug: s.slug || s.id,
          image: s.image || null,
          desc: s.short_description || s.description || '',
        })));
      }
    });
  }, [slug]);

  const handleInquire = () => {
    const message = `Hello AFS, I am interested in your ${service?.title || ''} service.\nPlease provide me with more information. Thank you.`;
    sessionStorage.setItem('contact_prefill', JSON.stringify({
      subject: 'Service Request',
      message,
    }));
    navigate('/contact');
  };

  if (loading) {
    return (
      <>
        <Header />
        <div style={{paddingTop: '64px'}}>
          <section className="cd-section">
            <div className="wrap">
              <div className="comp-loading">Loading...</div>
            </div>
          </section>
        </div>
        <Footer />
      </>
    );
  }

  if (!service) {
    return (
      <>
        <Header />
        <div style={{paddingTop: '64px'}}>
          <section className="cd-section">
            <div className="wrap">
              <div className="comp-empty">
                <p>Service not found.</p>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      <div style={{paddingTop: '64px'}}>
        <section className="cd-section">
          <div className="wrap">
            <div className="cd-grid">
              {/* Image */}
              <div className="cd-image-wrap">
                {service.image ? (
                  <div className="cd-slider">
                    <img src={service.image} alt={service.title} className="cd-image" />
                  </div>
                ) : (
                  <div className="cd-image-placeholder">
                    <span>&#128736;</span>
                  </div>
                )}
              </div>

              {/* Info */}
              <div className="cd-info">
                <div className="cd-breadcrumb">
                  <a href="/services">Services</a> <span>/</span> <span>{service.title}</span>
                </div>
                <h1 className="cd-title">{service.title}</h1>

                {service.short_description && (
                  <p className="cd-short-desc">{service.short_description}</p>
                )}

                {service.description && (
                  <div className="cd-description" dangerouslySetInnerHTML={{ __html: service.description }} />
                )}

                <div className="cd-actions">
                  <button className="btn btn-y" onClick={handleInquire}>
                    Request Service &#8599;
                  </button>
                  <a href="/services" className="btn btn-dark">
                    &#8592; Back to Services
                  </a>
                </div>
              </div>
            </div>

            {/* Other Services */}
            {otherServices.length > 0 && (
              <div className="cd-related">
                <h2 className="cd-related-title">Other Services</h2>
                <div className="cd-related-grid">
                  {otherServices.map((s) => (
                    <Link to={`/services/${s.slug}`} className="cd-related-card" key={s.id}>
                      <div className="cd-related-img">
                        {s.image ? (
                          <img src={s.image} alt={s.name} />
                        ) : (
                          <div className="cd-related-placeholder">&#128736;</div>
                        )}
                      </div>
                      <div className="cd-related-body">
                        <h3 className="cd-related-name">{s.name}</h3>
                        <p className="cd-related-desc">{s.desc}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            )}
          </div>
        </section>
      </div>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

export default ServiceDetailPage;
